/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { IMLCExclusionState } from '../models/IMLCExclusionState';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ImlcExclusionStatesService {

    /**
     * @returns IMLCExclusionState
     * @throws ApiError
     */
    public static imlcExclusionStatesList(): CancelablePromise<Array<IMLCExclusionState>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/imlc-exclusion-states/',
        });
    }

}
